/**
 * "Your move" in the navigation (ADR 0076): duels waiting on this player, turns and
 * invitations together. Refreshed by the player's own topic, polled when the socket is shut.
 */
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { getDuel } from "@/duels/registry";
import { useTenant } from "@/core/tenant/TenantProvider";
import { useTopic } from "@/core/realtime/RealtimeProvider";
import { inboxTopic, useDuelInbox } from "./api";

export function DuelBadge({ userId }: { userId: number }) {
  const { t } = useTranslation();
  const tenant = useTenant();
  const queryClient = useQueryClient();
  const on = tenant.enabled_games.some((key) => getDuel(key));
  const inbox = useDuelInbox({ enabled: on });
  useTopic(on ? inboxTopic(userId) : null, (frame) => {
    if (frame.type === "duels.changed") void queryClient.invalidateQueries({ queryKey: ["duels"] });
  });
  const count = (inbox.data?.your_turn ?? 0) + (inbox.data?.invitations ?? 0);
  if (!on || count === 0) return null;
  return (
    <span className="bt-nav-link__badge" aria-label={t("duels.badge", { count })}>
      {count}
    </span>
  );
}
